const safeString = (value, fallback = '') => (typeof value === 'string' ? value : fallback);

export const MIN_VISUAL_SLOTS = 3;
export const MAX_VISUAL_SLOTS = 60;
export const VISUAL_SLOT_SECTIONS = [
  { key: 'ana_gorseller', label: 'ANA GORSELLER', slotIndex: 0 },
  { key: 'vitrin', label: 'VITRIN', slotIndex: 1 },
  { key: 'banko', label: 'BANKO', slotIndex: 2 },
  { key: 'kapi_girisi', label: 'KAPI GIRISI', slotIndex: 3 },
  { key: 'banko_ustu', label: 'BANKO USTU', slotIndex: 4 },
  { key: 'kampanya_kosesi', label: 'KAMPANYA KOSESI', slotIndex: 5 }
];
export const VISUAL_SLOTS_PER_SECTION = 6;

export const getSectionSlotIndices = (sectionIndex) => {
  const start = Math.max(0, Number(sectionIndex) || 0) * VISUAL_SLOTS_PER_SECTION;
  return Array.from({ length: VISUAL_SLOTS_PER_SECTION }, (_, i) => start + i);
};

export const getVisualSlotCount = (campaign) => {
  const raw = Array.isArray(campaign?.visualSlotImages) ? campaign.visualSlotImages : [];
  return Math.min(MAX_VISUAL_SLOTS, Math.max(MIN_VISUAL_SLOTS, raw.length));
};

export const getSlotImage = (campaign, index) => {
  const arr = Array.isArray(campaign?.visualSlotImages) ? campaign.visualSlotImages : [];
  const v = arr[index];
  if (typeof v !== 'string') return null;
  const s = v.trim();
  if (!s) return null;
  if (s.startsWith('data:')) return s;
  if (s.startsWith('http://') || s.startsWith('https://')) return s;
  return null;
};

/** İlgili fikir / açıklama (yönetim panelinde girilir; şube ekranında listelenir). */
export const getSlotIdeaNote = (campaign, index) => {
  const arr = Array.isArray(campaign?.visualSlotIdeaNotes) ? campaign.visualSlotIdeaNotes : [];
  const v = arr[index];
  if (v == null) return '';
  return String(v).trim();
};

/** Görsel dizisi uzunluğuna göre not dizisini doldur / kısalt. */
export const alignSlotIdeaNotesToImages = (images, ideaNotes) => {
  const n = Array.isArray(images) ? images.length : 0;
  const l = Array.isArray(ideaNotes) ? ideaNotes.map((x) => (x == null ? null : String(x))) : [];
  const next = l.slice(0, n);
  while (next.length < n) next.push(null);
  return next;
};

export const extFromDataUrl = (dataUrl) => {
  const m = /^data:image\/(jpeg|jpg|png|gif|webp|bmp)/i.exec(safeString(dataUrl));
  if (!m) {
    try {
      const clean = safeString(dataUrl).split('?')[0];
      const ext = clean.split('.').pop()?.toLowerCase();
      if (ext && ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp'].includes(ext)) {
        return ext === 'jpeg' ? 'jpg' : ext;
      }
    } catch (e) {
      // ignore
    }
    return 'png';
  }
  const t = m[1].toLowerCase();
  if (t === 'jpeg' || t === 'jpg') return 'jpg';
  return t;
};

export const downloadDataUrl = (dataUrl, filename) => {
  const src = safeString(dataUrl).trim();
  if (!src) return;
  const a = document.createElement('a');
  a.href = src;
  const isInlineData = src.startsWith('data:');
  if (isInlineData) {
    a.download = filename;
  } else {
    // Cross-origin Storage URL'lerinde download attr her zaman zorlanamaz.
    // Mevcut sekmeyi bozmamak için yeni sekmede aç.
    a.target = '_blank';
  }
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  a.remove();
};
